import checkPermissions from 'src/utils/checkPermissions'

/**
 * Checks whether a tab is visible for the current permission context.
 * @param {{permissions?: {anyOf?: string[], allOf?: string[]}}} tab - Tab descriptor.
 * @param {{permissions?: string[]} | null | undefined} permissionContext - Context with user permissions.
 * @returns {boolean} True when the tab should be visible.
 */
export const isTabAllowed = (tab, permissionContext) => {
    return checkPermissions(permissionContext, tab.permissions)
}

/**
 * Filters tabs by applying permission rules for the current user context.
 * @param {Array<{id: string, title: string, permissions?: {anyOf?: string[], allOf?: string[]}}>} tabs - All configured tabs.
 * @param {{permissions?: string[]} | null | undefined} permissionContext - Context with user permissions.
 * @returns {Array<{id: string, title: string, permissions?: {anyOf?: string[], allOf?: string[]}}>} Visible tabs.
 */
export const getVisibleTabs = (tabs, permissionContext) => {
    return tabs.filter((tab) => isTabAllowed(tab, permissionContext))
}

/**
 * Resolves the active tab id, falling back to the first visible tab when needed.
 * @param {Array<{id: string}>} visibleTabs - Tabs that passed permission filtering.
 * @param {string} requestedTabId - Tab id requested by state or props.
 * @returns {string} The selected tab id, or an empty string when no tabs are visible.
 */
export const getResolvedSelectedTabId = (visibleTabs, requestedTabId) => {
    if (visibleTabs.some((tab) => tab.id === requestedTabId)) {
        return requestedTabId
    }

    return visibleTabs[0]?.id || ''
}
